import { Document } from 'jsonapi-typescript';
import { Observable } from 'rxjs';
import { deserializer } from './deserializer';
import { AppSettingsResponse } from '../interfaces/app-settings-response.interface';

export function deserializeAppSettings(response: Document): Observable<AppSettingsResponse | null> {
	return new Observable<AppSettingsResponse | null>((observer) => {
		// Handle empty data array (no settings exist)
		const responseData = (response as any).data;
		if (!responseData || (Array.isArray(responseData) && responseData.length === 0)) {
			observer.next(null);
			observer.complete();
			return;
		}

		deserializer.deserialize(response, (err: Error, deserialized: any) => {
			if (err) {
				observer.error(err);
			} else {
				const data = Array.isArray(deserialized) ? deserialized[0] : deserialized;

				const settings =
					typeof data.settings === 'string' ? JSON.parse(data.settings) : data.settings;

				observer.next({
					id: data.id,
					settings: settings,
				});
				observer.complete();
			}
		});
	});
}
